import _ from 'lodash'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ContentGroup from '../content-group'
import {
  useThemeConfig,
} from '../../hook'
import useStyles from './footer-checkout-style'

const FooterCheckoutView = (props = {}) => {
  const { inventoryStoreCode, pickupStoreCode } = props
  const { container, containerFluid, checkoutLinks } = useStyles()
  const { t } = useTranslation()
  const { getConfig, getContentGroup } = useThemeConfig()

  const footerCheckoutLinkContentGroupProps = useMemo(() => ({
    footer: getConfig('config.ui.footerCheckoutLink.footer', true),
    ...getContentGroup('config.ui.footerCheckoutLink', {
      code: 'ecom_footer_checkout_link',
      template: 'List',
    }),
    ..._.omitBy(
      getContentGroup(
        `config.ui.footerCheckoutLink.${_.camelCase(inventoryStoreCode)}`,
        { code: null, template: null },
      ),
      _.isEmpty,
    ),
    ..._.omitBy(
      getContentGroup(
        `config.ui.footerCheckoutLink.${_.camelCase(pickupStoreCode)}`,
        { code: null, template: null },
      ),
      _.isEmpty,
    ),
    apiRequestCancelKey: 'footer_checkout_link',
  }), [getContentGroup, inventoryStoreCode, pickupStoreCode])

  return (
    <div className={containerFluid}>
      <div className={container}>
        <div className={checkoutLinks}>
          <ContentGroup {...footerCheckoutLinkContentGroupProps} />
        </div>
        <p>{t('ui.footerCheckout.copy')}</p>
      </div>
    </div>
  )
}

export default FooterCheckoutView
